import Box from '@mui/material/Box';
import List from '@mui/material/List';
import { useEffect } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { WsDrawer } from 'wisestep-base';

import { defaultTaskFilterValues } from '../../../features/tasks/utils/DefaultTaskFilterValues';
import { CreatedBwDatesFilter } from '../components';
import AdvanceFilterFooterBar from '../components/AdvanceFilterFooterBar';
import RecruitersFilter from '../components/RecruitersFilter';
import JobAdvanceFilterProps from '../models/JobsAdvanceFiltersProps ';
import TasksAdvanceFilterFormProps from '../models/TasksAdvanceFiltersFormProps';

const WsTasksAdvanceFilter = ({
  open,
  filterClose,
  onApplyFilters,
  defaultValues,
}: JobAdvanceFilterProps) => {
  const methods = useForm<TasksAdvanceFilterFormProps>({ defaultValues: {} });
  const { handleSubmit, reset } = methods;
  const onFormSubmit = (data: TasksAdvanceFilterFormProps) => {
    onApplyFilters(data);
    filterClose();
  };

  useEffect(() => {
    reset(defaultValues);
  }, [defaultValues, reset]);

  return (
    <FormProvider {...methods}>
      <WsDrawer
        title="Advanced Filters"
        open={open}
        onClose={() => filterClose()}
        size="medium"
        headerSize="medium"
      >
        <Box
          component="form"
          role="presentation"
          onSubmit={handleSubmit(onFormSubmit)}
          onReset={() => reset(defaultTaskFilterValues)}
        >
          <Box pb={8}>
            <List>
              <RecruitersFilter
                title="Created By"
                name="recruiters"
                defaultValue={defaultValues.recruiters}
              />
              <CreatedBwDatesFilter
                name="createBWDates.fromDateName"
                name1="createBWDates.toDateName"
              />
              <CreatedBwDatesFilter
                title="Updated Between"
                name="updatedBWDates.fromDateName"
                name1="updatedBWDates.toDateName"
              />
            </List>
          </Box>
          <AdvanceFilterFooterBar />
        </Box>
      </WsDrawer>
    </FormProvider>
  );
};
export default WsTasksAdvanceFilter;
